export const CONFETTI_MIN_DURATION = 3.8
export const CONFETTI_DURATION_VARIATION = 1.1
export const CONFETTI_MAX_DELAY = .45
export const CONFETTI_END = CONFETTI_MIN_DURATION + CONFETTI_DURATION_VARIATION + CONFETTI_MAX_DELAY
// A animação atinge a borda inferior aos 88% do percurso de queda.
export const CONFETTI_LANDING_SOUND_START = CONFETTI_MIN_DURATION * .88
